import { gql, useQuery } from "@apollo/client";

export type PaymentLinkResponse = {
  paymentLink: {
    link: string;
  };
};

const PaymentLinkQuery = gql`
  query paymentLink {
    paymentLink {
      link
    }
  }
`;

export const usePaymentLinkQuery = (options?: {
  skip?: boolean;
}) =>
  useQuery<PaymentLinkResponse>(PaymentLinkQuery, {
    fetchPolicy: "no-cache",
    nextFetchPolicy: "cache-first",
    ...options,
  });
